import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { to: '/', label: t('nav.home') },
        { to: '/about', label: t('footer.about') },
        { to: '/category/pingtai-jieshao', label: t('nav.categories') },
        { to: '/category/changjian-wenti', label: '常见问题' },
      ],
    },
    {
      title: '服务支持',
      links: [
        { to: '/category/shiyong-zhinan', label: '使用指南' },
        { to: '/category/anquan-zixun', label: '安全资讯' },
        { to: '/category/huiyuan-fuwu', label: '会员服务' },
        { to: '/about', label: '客服中心' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { to: '/about', label: '品牌介绍' },
        { to: '/about', label: '发展历程' },
        { to: '/about', label: '用户口碑' },
        { to: '/about', label: t('footer.contact') },
      ],
    },
  ];

  const legalLinks = [
    { to: '/about', label: t('footer.privacy') },
    { to: '/about', label: t('footer.terms') },
    { to: '/category/changjian-wenti', label: t('footer.help') },
  ];

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm">
                  金
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  {t('site.name')}
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                金宝博是您信赖的首选平台，为您提供安全、便捷、专业的一站式服务体验。服务全球数百万用户，满意度高达98.5%。
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-md text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-md text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-md text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-lg"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-4 flex-wrap justify-center">
              {legalLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}